/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More typing tests`)
};

const es_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más tests de mecanografía`)
};

const de_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Tipptests`)
};

const nl_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meer typetests`)
};

const fr_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus de tests de frappe`)
};

const it_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri test di digitazione`)
};

const pt_br2_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais testes de digitação`)
};

const pt_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais testes de escrita`)
};

const ja_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のタイピングテスト`)
};

const zh_typing_more_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多打字测试`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_more_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_more_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_more_title", locale)
	if (locale === "en") return en_typing_more_title(inputs)
	if (locale === "es") return es_typing_more_title(inputs)
	if (locale === "de") return de_typing_more_title(inputs)
	if (locale === "nl") return nl_typing_more_title(inputs)
	if (locale === "fr") return fr_typing_more_title(inputs)
	if (locale === "it") return it_typing_more_title(inputs)
	if (locale === "pt-BR") return pt_br2_typing_more_title(inputs)
	if (locale === "pt") return pt_typing_more_title(inputs)
	if (locale === "ja") return ja_typing_more_title(inputs)
	return zh_typing_more_title(inputs)
};